import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { requestInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';

export interface outOfOfficeInterface {
	startDate: string;
	endDate: string;
	enduser: string;
	idResponsible: string;
	nameResponsible: string;
	emailResponsible: string;
}

@Injectable({
	providedIn: 'root',
})
export class OutOfOfficeService {
	private outOfOfficeUrl = environment.baseApiUrl + 'outOfOffice';
	private outOfOfficeAccordionUrl = environment.baseApiUrl + 'outOfOffice/accordion';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getMyOutOfOfficeData(): Observable<outOfOfficeInterface> {
		return this.http.get<outOfOfficeInterface>(this.outOfOfficeUrl, { headers: this.headers });
	}

	setMyOutOfOffice(startDate: string, endDate: string, emailResponsible: string): Observable<any> {
		return this.http.post(
			this.outOfOfficeUrl,
			{ startDate: startDate, endDate: endDate, emailResponsible: emailResponsible },
			{ headers: this.headers }
		);
	}

	updateMyOutOfOffice(startDate: string, endDate: string, emailResponsible: string): Observable<any> {
		return this.http.put(
			this.outOfOfficeUrl,
			{ startDate: startDate, endDate: endDate, emailResponsible: emailResponsible },
			{ headers: this.headers }
		);
	}

	removeSchedule(): Observable<any> {
		return this.http.delete(this.outOfOfficeUrl, { headers: this.headers });
	}

	getAccordion(): Observable<accordionInterface[]> {
		return this.http
			.get(this.outOfOfficeAccordionUrl, { headers: this.headers })
			.pipe(
				catchError((error) => {
					return of([]);
				})
			)
			.pipe(
				map((accordionRes: any) => {
					const accordionArray: accordionInterface[] = [];

					for (const accordion of accordionRes) {
						const newAccordion: accordionInterface = {
							id: accordion.id ? accordion.id : accordion.listName.replaceAll(' ', '_'),
							name: accordion.listName,
							type: accordion.type,
							dataType: 'request',
							border: accordion.border,
							alert: accordion.alert,
							request: [],
							accordionLength: 0,
							hidden: false,
						};

						for (const request of accordion.request) {
							const newRequest: requestInterface = {
								id: request.id,
								sla_remaining: <number>request.slaRemaining,
								service_type: request.service_type,
								scope: request.scope,
								category: request.category,
								topic: request.topic,
								solution_area: request.solution_area,
								status: request.status,
								summary: request.summary,
								id_enduser: request.idenduser,
								description: request.description,
								limit_date: request.limit_date,
								open_date: request.open_date,
								registered_by: request.registered_by,
								analyst: request.analyst,
								enduser: request.enduser,
								department: request.department,
								site: request.site,
								location: request.location,
							};

							for (let index = 0; index < Object.keys(request).length; index++) {
								const selObjectKey = Object.keys(request)[index];
								if (selObjectKey.startsWith('customfield_')) {
									newRequest[selObjectKey] = request[selObjectKey];
								}
							}
							newAccordion.request.push(newRequest);
						}

						newAccordion.accordionLength = newAccordion.request.length;

						accordionArray.push(newAccordion);
					}

					return accordionArray;
				})
			);
	}
}
